import { useGetScheduledPickByIdQuery } from 'common/api/endpoints/schedule';
import { handleError } from 'common/api/utils/handleError';
import { WithLoadingOverlay } from 'common/components/LoadingSpinner';
import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Constants } from 'utils/constants';
import { CrewAssignmentWizard } from '../components/CrewAssignmentWizard/CrewAssignmentWizard';

export const CrewAssignmentWizardView: FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { data, isFetching, error } = useGetScheduledPickByIdQuery({
    id: parseInt(id, 10),
  });

  useEffect(() => {
    if (error) {
      handleError(error, 'Unable to load scheduled pick data.');
      history.replace(`${Constants.routes.PICK_SCHEDULE}/${id}`);
    }
  }, [error, history, id]);

  return (
    <WithLoadingOverlay isLoading={isFetching}>
      {data && <CrewAssignmentWizard scheduledPick={data} />}
    </WithLoadingOverlay>
  );
};
